import PropTypes from 'prop-types';

import { STORIES } from '@/lib/posts/postTypes';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    TWITTER,
    YOUTUBE
} from '@/lib/socialProfile';

import FacebookPost from '@/components/base/Post/FacebookPost';
import InstagramPost from '@/components/base/Post/InstagramPost';
import InstagramStory from '@/components/base/Post/InstagramStory';
import LinkedinPost from '@/components/base/Post/LinkedinPost';
import PinterestPost from '@/components/base/Post/PinterestPost';
import TiktokPost from '@/components/base/Post/TiktokPost';
import TwitterPost from '@/components/base/Post/TwitterPost';
import YoutubePost from '@/components/base/Post/YoutubePost';

export const PostComponent = ({ network, type, ...restProps }) => {
    switch (network) {
        case INSTAGRAM:
            if (type === STORIES) {
                return <InstagramStory {...restProps} />;
            }
            return <InstagramPost {...restProps} />;
        case TIKTOK_BUSINESS:
            return <TiktokPost {...restProps} />;
        case FACEBOOK:
            return <FacebookPost {...restProps} />;
        case LINKEDIN:
            return <LinkedinPost {...restProps} />;
        case PINTEREST:
            return <PinterestPost {...restProps} />;
        case TWITTER:
            return <TwitterPost {...restProps} />;
        case YOUTUBE:
            return <YoutubePost {...restProps} />;
        default:
            return <InstagramPost {...restProps} />;
    }
};

PostComponent.propTypes = {
    network: PropTypes.oneOf([
        INSTAGRAM,
        FACEBOOK,
        LINKEDIN,
        PINTEREST,
        TWITTER,
        TIKTOK_BUSINESS,
        YOUTUBE
    ]),
    type: PropTypes.oneOf(['medias', 'stories'])
};
